import { useContext, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppContext } from './app-context';
import './App.scss';
import MessageComponent from './components/message-dialog/message.component';
import MessageDialog from './components/message-dialog/message-dialog.component';
import { EMPTY_STRING } from './features/common/constants';
import { isNotEmpty, isNotNull } from './features/common/util.services';
import { getCurrentUser } from './features/user/user.services';
import MainLayout from './features/common/main-layout.component';
import MobileLayout from './features/common/mobile-layout.component';
import SigninComponent from './features/user/signin/signin.component';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/system';

const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [loader, setLoader] = useState(true);
  const [userData, setUserData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(EMPTY_STRING);
  const [successMessage, setSuccessMessage] = useState(EMPTY_STRING);
  const [dialogMessage, setDialogMessage] = useState(EMPTY_STRING);
  const appContext = useContext(AppContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (userData === null) {
      initUserData();
    }
  }, []);

  const initUserData = () => {
    getCurrentUser(appContext,
      (response: any) => {
        if (isNotNull(response) && isNotEmpty(response.rowId)) {
          setUserData(response);
        }
        setLoader(false);
        setShowLoader(false);
      }, (error: any) => {
        setLoader(false);
        setShowLoader(false);
      }
    );
  }

  const showMessageDialog = () => {
    return dialogMessage !== EMPTY_STRING;
  }

  const mainRoute = () => {
    return <BrowserRouter>
      <Routes>
      <Route path='/*' element={isNotNull(userData) ? (!isMobile ? <MainLayout /> : <MobileLayout/>) : <SigninComponent />} />
      <Route path='/signin' element={<SigninComponent />} />
      </Routes>
      {/* <MainLayout></MainLayout> */}
    </BrowserRouter>
  }


  return (
    <AppContext.Provider value={{
      userData, setUserData, errorMessage, setErrorMessage, successMessage,
      setSuccessMessage, showLoader, setShowLoader, setDialogMessage
    }}>
      <MessageComponent />
      <MessageDialog open={showMessageDialog()} onClose={() => { setDialogMessage(EMPTY_STRING) }} message={dialogMessage} />
      {/* {showLoader ? <Loader /> : mainRoute()} */}
      {!loader && mainRoute()}
      {/* {showLoader ? <Loader/> : <MainRouter></MainRouter>} */}
    </AppContext.Provider>
  );
}

export default App;
